<script>
    import { onMount } from 'svelte';
    import NightVariationGraph from './NightVariationGraph.svelte';
    import SpectralGraph from '../Misc/SpectralGraph.svelte';
    import HistoryGraph from './HistoryGraph.svelte';
    import WPNSelector from "../Misc/WPNSelector.svelte";
	import { audioUrlFromAnalysis, dateOptionsForSensor } from '../../scripts/alfxSurvey.js';
    import Base64AudioPlayer from './Base64AudioPlayer.svelte';
    import dbData from "../../Stores/utilityDBStore.js";

    const apiUrl = process.env.VITE_API_URL;
    const apiNA = process.env.VITE_API_NA

    // Using D3 in svelte: https://www.connorrothschild.com/post/svelte-and-d3
    // Intro:  https://dev.to/learners/series-intro-data-visualization-with-svelte-and-d3-4c07
    // Svelte bar chart: https://svelte.dev/repl/8722c32f4e1a44a98e3a3fc8a095b2d7?version=3.5.3
    // Svelte line graph: https://svelte.dev/repl/8262eb73a08f48adba8e0b706c1a939f?version=3.22.1

	export let sensor;
    let slDay = undefined;
    let promise = null;

    $: slDay = getInitialDay(sensor);
    $: if (slDay != undefined) {
        const id32 = (sensor.device_sn ?? sensor.name).replace(/\D/g, '');
        const url = apiUrl + $dbData.wpn_id + apiNA + id32 + "-" + slDay + ".json";
        promise = getAnalysisJSON(url);
    } else {
        promise = null;
    }

    onMount(() => {
        slDay = getInitialDay(sensor);
    });

    async function getAnalysisJSON(url) {
        if (url == undefined) {
            return {};
        }
        try {
            const resA = await fetch(url);
            if (resA.ok) {
                let result = await resA.json();
                // console.log("History for: ", sensor.name, result);
                return result;
            } else {
                return {};
            }
        } catch(error) {
            console.error('Error fetching Analysis JSON: ', error);
            return {}
        }
    }

    function setCurrentDay(event) {
        slDay = event.detail.value;
        console.log("Selection of survey day is ", slDay);
    }

    function getInitialDay(item) {
        if (isValidSensor(item)) {
            let analysisDays = Array.isArray(item.days) ? item.days : [];
            analysisDays.sort((a, b) => b - a);
            return analysisDays[0];
        }
        return undefined;
    }

    function isValidSensor(item)
    {
        return (item != undefined) && (item.entity == 'Sensor');
    }

</script>

{#if isValidSensor(sensor) && slDay}
<div class="detail-section">
    {#if promise}
        {#await promise}
            <p>Loading analysis data...</p>
        {:then analysis}
            <div class="split-title-buttons">
                <div class="detail-section-title split-view-title">Sensor Analysis</div>
                <label id="days-label" for="days1">Survey Date:</label>
                <WPNSelector
                    styleOverride="margin-top: -6px; margin-left: 2px;"
                    selectorOptions={dateOptionsForSensor(sensor)}
                    selectorName="days1"
                    selected={slDay}
                    on:selector-changed={setCurrentDay}
                />
            </div>
            <Base64AudioPlayer audioName={sensor.name ?? ""} audioUrl={audioUrlFromAnalysis(analysis, $dbData.wpn_id)} willLoop={true}/>
            {#if Array.isArray(analysis.h_64_night) == true}
                <HistoryGraph {analysis} />
            {/if}
            {#if Array.isArray(analysis.night_variation) == true}
                <NightVariationGraph {analysis} />
            {/if}
            {#if Array.isArray(analysis.quiescent_spectrum) == true}
                <SpectralGraph {analysis} />
            {/if}
        {:catch error}
            <p style="color: gray">{error.message}</p>
        {/await}
    {:else}
        <div class="detail-section-title split-view-title">Sensor Analysis</div>
        <p>No analysis data is available.</p>
    {/if}
</div>
{/if}

<style>
    #days-label {
        margin-top: 2px;
        margin-right: 4px;
    }
</style>